import moment from 'moment';
import _ from 'lodash';
import { ModalController } from '../common/modal.controller.js';
import { Column12, Column6, Column4, Row } from '../common/forms/layout.js';
import { OTVOREN, UOBRADI } from '../radniNalog/statusi.js';

class DashboardController {
    constructor($state, AppConfiguration, DS, $uibModal) {
        let app = AppConfiguration();
        this.$uibModal = () => $uibModal;
        this.entityRN = app.getEntity('dashboard');
        this.fields = this.entityRN.listView().fields();
        this.datastore = () => {
            return DS;
        };

        this.listActions = this.entityRN.listView().listActions();
        this.$state = $state;
        this.params = {
            limit: 10,
            offset: 0,
            status: UOBRADI
        };
    }

    $onInit() {
        this.calendarDate = moment();
        this.otvoreniNalozi = [];
        this.refreshState(this.params);
        this.getForToday();
        this.mode = 'danas';
        this.heatData = {};

        const start = moment([this.calendarDate.year(), this.calendarDate.month(), 1]);
        const end = moment(start)
            .add(1, 'months')
            .add(-1, 'days');
        this.getFaze(start, end);
    }

    refreshState(params) {
        let DS = this.datastore();
        DS.findAll('RadniNalog', { limit: 20, offset: 0, status: OTVOREN }, { bypassCache: true }).then(response => {
            this.otvoreniNalozi = response;
        });

        DS.findAll('Ordinacija')
            .then(response => {
                return DS.findAll('RadniNalog', params, { bypassCache: true });
            })
            .then(response => {
                this.entries = response;
            });
    }

    edit(item) {
        this.$state.go('radniNalog.details', { id: item.id });
    }

    onFilter(item) {
        this.params.search = item;
        this.refreshState(this.params);
    }

    getFaze(start, end) {
        let DS = this.datastore();
        DS.findAll(
            'FazaNaloga',
            {
                aktivne: 1,
                datum_probe_range_0: start.format('YYYY-MM-DD'),
                datum_probe_range_1: end.format('YYYY-MM-DD')
            },
            { bypassCache: true }
        ).then(response => {
            const faze = {};
            response.map(r => {
                if (faze[r.datum_probe] === undefined) {
                    faze[r.datum_probe] = 1;
                } else {
                    faze[r.datum_probe] = faze[r.datum_probe] + 1;
                }
            });
            this.heatData = faze;
        });
    }

    calendarViewChange(year, month) {
        let start = moment([year, month, 1]);
        let end = moment(start)
            .add(1, 'months')
            .add(-1, 'days');
        this.getFaze(start, end);
    }

    dateChange(value) {
        this.getForDay(moment(value).format('YYYY-MM-DD'));
        this.calendarDate = moment(value);
    }

    getForToday() {
        this.mode = 'danas';
        this.days = [moment().format('YYYY-MM-DD')];
        this.day = this.days[0];
    }

    getForNextDay() {
        this.mode = 'sutra';
        this.days = [
            moment()
                .add(1, 'days')
                .format('YYYY-MM-DD')
        ];
        this.day = this.days[0];
    }

    getForDay(day) {
        this.mode = 'custom';
        this.days = [day];
        this.day = this.days[0];
    }

    getForWeek() {
        this.mode = 'tjedan';
        this.days = [
            moment().format('YYYY-MM-DD'),
            moment()
                .add(1, 'days')
                .format('YYYY-MM-DD'),
            moment()
                .add(2, 'days')
                .format('YYYY-MM-DD'),
            moment()
                .add(3, 'days')
                .format('YYYY-MM-DD'),
            moment()
                .add(4, 'days')
                .format('YYYY-MM-DD'),
            moment()
                .add(5, 'days')
                .format('YYYY-MM-DD')
        ];
        this.day = null;
        this.datum_od = this.days[0];
        this.datum_do = this.days[5];
    }

    findByQrCode() {
        const $uibModal = this.$uibModal();
        const modalInstance = $uibModal.open({
            size: 'lg',
            component: 'modalQr'
        });

        modalInstance.result.then(content => {
            if (_.isFinite(parseInt(content))) {
                this.edit({ id: content });
            }
        });
    }
}

DashboardController.$inject = ['$state', 'AppConfiguration', 'DS', '$uibModal'];

export { DashboardController };



// WEBPACK FOOTER //
// ./app/components/dashboard/dashboard.controller.js